import React from "react";
import "./loader.css";
import { Spinner } from "react-bootstrap";
function Loader() {
  return (
    <>
      <div class="load">
        <div class="three col">
          <div class="loader" id="loader-6">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Loader;
